import React from 'react';
import styled from 'styled-components';
import * as Ant from 'antd';
import {useOutlet, useOutletSetter} from 'reconnect.js';
import * as AppActions from '../../AppActions';
import {KeyboardArrowRight} from '@styled-icons/material/KeyboardArrowRight';
import {KeyboardArrowDown} from '@styled-icons/material/KeyboardArrowDown';
import * as NavUtil from '../../Utils/NavUtil';
import {Link} from 'gatsby';
import {Line} from '@styled-icons/fa-brands/Line';
import {FacebookSquare} from '@styled-icons/fa-brands/FacebookSquare';

export default function NavBarDrawer({
  visible,
  setVisible,
  navItems,
  isDoctor,
}) {
  const showLoginModal = useOutletSetter('login-modal');
  const [expand, setExpand] = React.useState({});

  const [user] = useOutlet('user');

  return (
    <>
      <Backdrop visible={visible} onClick={() => setVisible(false)} />
      <MobileContent visible={visible}>
        {isDoctor && (
          <div className={'header'}>
            {user ? (
              <Link to="/doctor/member">Hi, {user.data?.name}</Link>
            ) : (
              <a
                href="#"
                onClick={() => {
                  showLoginModal(true);
                }}>
                登入
              </a>
            )}
            <div className="row">
              <Link to="/doctor">首頁</Link>
              <Link to="/doctor/contact">聯絡我們</Link>
              <Link to="/doctor/links">相關網站</Link>
              <a
                target="_blank"
                href="https://facebook.com/120275868022597"
                rel="noreferrer">
                <FacebookSquare size={30} color="#fff" />
              </a>
              <a
                target="_blank"
                href="http://line.me/ti/p/E3m_fsOMYR"
                rel="noreferrer">
                <Line size={30} color="#fff" />
              </a>
            </div>
          </div>
        )}

        <div className="nav-items">
          {navItems.map((navItem, idx) => {
            const selected = NavUtil.isNavLinkSelected(navItem);

            return (
              <React.Fragment key={idx}>
                <Link
                  to={navItem.path}
                  className={'nav-item' + (selected ? ` selected ` : ``)}
                  onClick={(e) => {
                    if (navItem.entries?.length > 0) {
                      e.preventDefault();

                      setExpand((prev) => ({
                        ...prev,
                        [navItem.name]: !prev[navItem.name],
                      }));
                    }
                  }}>
                  {navItem.name}
                  {navItem.entries?.length > 0 && (
                    <KeyboardArrowDown
                      size={30}
                      color="#fff"
                      className={expand[navItem.name] ? ' expand ' : ''}
                    />
                  )}
                </Link>
                <div
                  className={
                    'nav-item-children' +
                    (expand[navItem.name] ? ' expand ' : '')
                  }>
                  {(navItem.entries || []).map((item, i) => (
                    <Link
                      to={item.path}
                      key={`item-${i}`}
                      className={`nav-item-child`}>
                      {item.name}
                    </Link>
                  ))}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </MobileContent>
    </>
  );
}

const Backdrop = styled.div`
  z-index: 101;
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
  transition: 300ms;
`;

const MobileContent = styled.div`
  --drawer-width: 350px;

  z-index: 101;
  position: fixed;
  top: 0;
  left: 0;
  width: var(--drawer-width);
  height: 100vh;
  overflow: scroll;
  background-color: var(--primaryColor);
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.31);
  display: flex;
  flex-direction: column;
  transition: 300ms;
  pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: ${(props) =>
    props.visible
      ? 'translateX(0px)'
      : 'translateX(calc(-1 * var(--drawer-width)))  skew(-30deg)'};

  & > .header {
    height: 110px;
    flex-shrink: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    & > .row {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      margin-top: 10px;
    }
    & a {
      color: #fff;
    }
  }

  & > .nav-items {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;

    & .nav-item {
      padding: 14px 20px;
      font-size: 1.1rem;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    & .nav-item > .svg {
      transition: transform 0.2s;
    }
    & .nav-item > .svg.expand {
      transform: rotate(90deg);
    }

    & .nav-item-children {
      max-height: 0;
      transition: max-height 0.4s ease-in-out;
      overflow: hidden;
    }
    & .nav-item-children.expand {
      max-height: 1000px;
    }

    & .nav-item-child {
      display: block;
      padding: 10px 0px 10px 40px;
      font-size: 1rem;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.1);
      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }

    & .nav-item:not(:last-child),
    & .nav-item-child:not(:last-child) {
      border-bottom: solid 1px rgba(0, 0, 0, 0.2);
    }

    & .selected {
    }
  }
`;
